export const IGNORED_RELANCES_ROUTE = '/relances/ignorees';
export const UPCOMING_RELANCES_ROUTE = '/relances/a-venir';
